import { ReactNode } from 'react';

import { ActionBar } from '@dreryk/react-components';

type HealthcareProviderActionBarProps = {
   readonly children: ReactNode;
};

export const HealthcareProviderActionBar = (props: HealthcareProviderActionBarProps): JSX.Element => {
   return (
      <ActionBar id='healthcare-provider-action-bar' testId='healthcareProvider'>
         {props.children}
      </ActionBar>
   );
};
